<div class="card">
  <div class="card-content">
    <ng-container *ngIf="isSucceed">
      <div class="notification is-primary is-light">
        {{"PASSWORD_RESET_LINK_SENT_TO_YOUR_EMAIL" | translate}}.
      </div>

      <a class="button is-light is-fullwidth" [routerLink]="['/auth/login']"
        >{{"BACK_TO_LOGIN" | translate}}</a
      >
    </ng-container>

    <form *ngIf="!isSucceed" (submit)="onSubmit($event)">
      <h4
        class="is-size-5"
        style="
          margin-bottom: 15px;
          text-align: center;
          text-transform: uppercase;
        "
      >
        {{"PASSWORD_RESET" | translate}}
      </h4>
      <div class="field">
        <div class="control has-icons-left has-icons-right">
          <input
            (input)="handleFieldChange($event)"
            class="input"
            type="email"
            name="email"
            [ngClass]="{ 'is-danger': hasError('email') }"
            [placeholder]="'EMAIL' | translate"
          />
          <span class="icon is-small is-left">
            <i class="fas fa-envelope"></i>
          </span>
        </div>
        <p class="help is-danger" *ngIf="hasError('email')">
          {{ getError('email') }}
        </p>
      </div>

      <div class="is-flex buttons">
        <button
          class="button is-link is-outlined is-fullwidth"
          type="submit"
          [disabled]="isLoading"
        >
          {{"SUBMIT" | translate}}
        </button>

        <a class="button is-light is-fullwidth" [routerLink]="['/auth/login']"
          >{{"BACK_TO_LOGIN" | translate}}</a
        >
      </div>
    </form>
  </div>
</div>
